export const outlineStyles = `focus:tw-outline-tci-purple focus:tw-outline tw-transition-all tw-rounded
                              focus:tw-outline-2 focus:tw-outline-offset-2`;
